import _defineProperty from "/u01/jenkins/workspace/CloudFront-NodeJS/tgp-texasgov-ui/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _ALERT_CONFIG;

import React from 'react';
import { InfoIcon } from '../icons/InfoIcon';
import { WarningIcon } from '../icons/WarningIcon';
export var TxAlertType;

(function (TxAlertType) {
  TxAlertType["Error"] = "error";
  TxAlertType["Warning"] = "warning";
  TxAlertType["Info"] = "info";
})(TxAlertType || (TxAlertType = {}));

var ALERT_CONFIG = (_ALERT_CONFIG = {}, _defineProperty(_ALERT_CONFIG, TxAlertType.Error, {
  Icon: WarningIcon
}), _defineProperty(_ALERT_CONFIG, TxAlertType.Warning, {
  Icon: WarningIcon
}), _defineProperty(_ALERT_CONFIG, TxAlertType.Info, {
  Icon: InfoIcon
}), _ALERT_CONFIG);
export function TxAlert(_ref) {
  var heading = _ref.heading,
      children = _ref.children,
      iconOverride = _ref.iconOverride,
      className = _ref.className,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? TxAlertType.Warning : _ref$type;
  var Icon = ALERT_CONFIG[type].Icon;
  var extraClass = className ? " ".concat(className) : '';
  return React.createElement("div", {
    className: 'tx-alert ' + 'tx-alert--' + type + extraClass
  }, React.createElement("div", {
    className: "tx-alert__icon"
  }, iconOverride || React.createElement(Icon, null)), React.createElement("div", {
    className: "tx-alert__content"
  }, React.createElement("div", {
    className: "tx-alert__content__heading"
  }, heading), React.createElement("div", {
    className: "tx-alert__content__body"
  }, children)));
}